module.exports = __webpack_public_path__ + "img/Briefcase.c3fba06f.png";